import {
  GET_ALL_BRAND_REQUEST,
  GET_ALL_BRAND_SUCCESS,
  GET_ALL_BRAND_FAILURE,
} from "./ActionType";

const initialState = {
  brands: [],
  loading: false,
  error: "",
};

export const publicBrandReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_BRAND_REQUEST:
      return { ...state, loading: true };

    case GET_ALL_BRAND_SUCCESS:
      return { ...state, loading: false, error: "", brands: action.payload };

    case GET_ALL_BRAND_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
